import * as React from 'react'

interface IfProps {
  children: any | any[]
  condition: boolean
}

const If: React.FC<IfProps> = ({ children, condition }) => {
  if (condition) {
    return <React.Fragment>{children}</React.Fragment>
  }
  return null
}

export default If
